export default __webpack_public_path__ + "static/LaSirena-e9c7acf686fc072bd7a305cdab4be91f.png";